module.exports = __webpack_public_path__ + "static/img/br.87032851.svg";